/** Local account identifiers only. Authentication always uses the normal server flow. */
export const RECENT_LOGIN_ACCOUNTS_KEY = 'aurax-recent-login-accounts:v1';
const MAX_ACCOUNTS = 5;
function validIdentifier(value) {
  return typeof value === 'string' && value.trim().length > 0 && value.trim().length <= 128 && !/[\u0000-\u001f\u007f]/.test(value);
}
function normalized(rows) {
  if (!Array.isArray(rows)) return [];
  const seen = new Set();
  return rows.filter(row => row && validIdentifier(row.identifier) && Number.isFinite(row.lastUsedAt) && row.lastUsedAt > 0)
    .map(row => ({ identifier: row.identifier.trim(), lastUsedAt: row.lastUsedAt }))
    .sort((a,b) => b.lastUsedAt-a.lastUsedAt)
    .filter(row => { const key=row.identifier.toLocaleLowerCase(); if (seen.has(key)) return false; seen.add(key); return true; })
    .slice(0,MAX_ACCOUNTS);
}
export function readRecentLoginAccounts(storage) {
  try {
    const raw=(storage || window.localStorage).getItem(RECENT_LOGIN_ACCOUNTS_KEY);
    if (!raw || raw.length > 32768) return [];
    const parsed=JSON.parse(raw);
    return parsed?.version === 1 ? normalized(parsed.accounts) : [];
  } catch { return []; }
}
export function rememberLoginAccount(identifier, remember=true, storage, now=Date.now()) {
  const existing=readRecentLoginAccounts(storage);
  if (!validIdentifier(identifier)) return existing;
  const clean=identifier.trim();
  const rows=existing.filter(row => row.identifier.toLocaleLowerCase() !== clean.toLocaleLowerCase());
  if (remember && Number.isFinite(now) && now > 0) rows.push({ identifier:clean,lastUsedAt:now });
  const result=normalized(rows);
  try {
    const target=storage || window.localStorage;
    if (result.length) target.setItem(RECENT_LOGIN_ACCOUNTS_KEY,JSON.stringify({version:1,accounts:result}));
    else target.removeItem(RECENT_LOGIN_ACCOUNTS_KEY);
    return result;
  } catch { return existing; }
}
